import { interceptorMiddleware } from '../../../shared/services/interceptor.service';
import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethods } from '../../../shared/constants/application.constant';
import { NotificationForm } from '../utils/types.promotion';
import { apiUrlNotification } from '../utils/apiUrl.notification';

// Define a service using a base URL and expected endpoints
export const notificationApi = createApi({
    reducerPath: 'notification',
    baseQuery: interceptorMiddleware,
    tagTypes: ['notification'],
    endpoints: (builder) => ({
        sendNotification: builder.mutation({
            query: (data: NotificationForm) => {
                return {
                    url: apiUrlNotification.ADMIN_NOTIFICATIONS,
                    method: HttpMethods.POST,
                    body: data,
                };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSendNotificationMutation } = notificationApi;
